import { ILocationEntity } from '../types/location.types';
import { sortByName } from '../components/bootstrap/location/methods';

import { awaitingLocations } from '../components/bootstrap/location/bootstrap';

document.addEventListener('alpine:init', function () {

	const Alpine = window['Alpine'];

	Alpine.data('allStoresList', (region) => ({
		list: [],
		loading: true,

		get locationsCountForRegion() {
			return this.list.length;
		},
		init() {
			awaitingLocations.then((locations) => {
				this.list = locations.filter((location: ILocationEntity) => {
					try {
						return location.region.includes(region);
					}
					catch (error) {
						return false;
					}
					
				});
				this.list.sort(sortByName);
				this.loading = false;
			});
		}
	}));
});
